import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { addFaq, getFaq } from "../../reducers/commonReducer";

const schema = yup.object().shape({
  question: yup.string().required("Question is required"),
  answer: yup.string().required("Answer is required"),
  
});

function FaqAdd() {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Add FAQ
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add New FAQ</Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={schema}
          onSubmit={async (values, { resetForm }) => {
            await dispatch(addFaq({ ...values, status: values.status === "true" }));
            resetForm();
            handleClose();
            setTimeout(() => dispatch(getFaq()), 300);
          }}
          initialValues={{
            question: "",
            answer: "",
           
          }}
        >
          {({ handleSubmit, handleChange, values, setFieldValue, errors }) => (
            <Form className="container" onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Col md={12} sm={12}>
                  <Form.Group controlId="question">
                    <Form.Label>Question</Form.Label>
                    <Form.Control
                      type="text"
                      name="question"
                      placeholder="Enter question"
                      value={values.question}
                      onChange={handleChange}
                      isInvalid={!!errors.question}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.question}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12} sm={12}>
                  <Form.Group controlId="answer">
                    <Form.Label>Answer</Form.Label>
                    <Form.Control
                      type="text"
                      name="answer"
                      placeholder="Enter answer"
                      value={values.answer}
                      onChange={handleChange}
                      isInvalid={!!errors.answer}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.answer}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
               
              </Row>

              <Modal.Footer>
                <Button variant="success" type="submit">Submit</Button>
                <Button variant="secondary" onClick={handleClose}>Close</Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

export default FaqAdd;
